import React from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useUi } from "@jelly/lesson";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "./Challenges.messages";
import styles from "./Challenges.module.scss";

interface Challenges {
  title: string;
}

export const Challenges: React.FC<Challenges> = ({ title }) => {
  const ui = useUi();
  const { formatMessage } = useIntl();

  const leftComponent = (
    <div className={styles.leftComponent}>
      <ui.Scrollbars>
        <div className={styles.description}>
          <p>{formatMessage(messages.challengesDescription)}</p>
        </div>
      </ui.Scrollbars>
    </div>
  );

  return (
    <StandardCase title={title} leftComponent={leftComponent}>
      <div className={styles.rightComponent}>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
        <SpatialCarousel showBreadcrumbs>
          {[
            <div key={1} className={styles.carouselItem}>
              <h3 className={styles.title}>{formatMessage(messages.challengesTitle2)}</h3>
              <ui.Scrollbars>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.challengesDescription2) }}></p>
              </ui.Scrollbars>
            </div>,
            <div key={2} className={styles.carouselItem}>
              <h3 className={styles.title}>{formatMessage(messages.challengesTitle3)}</h3>
              <ui.Scrollbars>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.challengesDescription3) }}></p>
              </ui.Scrollbars>
            </div>,
          ]}
        </SpatialCarousel>
      </div>
    </StandardCase>
  );
};
